import "./SeletorDeEmpresa.css";

/**
 * Escolhe de qual empresa é o que se está vendo.
 *
 * <p>O grupo tem <b>três pessoas jurídicas</b> e um setor de Regulatório único
 * atendendo todas ([ADR-0005]). Quem alterna entre três o dia inteiro vai
 * confundi-las — e atribuir um documento ao CNPJ errado é documento inválido.
 * A interface tem que dificultar isso, não facilitar.
 *
 * <p>Por isso o componente é de {@code packages/ui} e não de um módulo: ele
 * precisa parecer e se comportar igual em toda tela com dado regulado.
 *
 * <p>O padrão é <b>consolidado</b>, porque a pergunta da diretoria é sobre o
 * grupo. Mas selecionar "todas" não dispensa cada item de dizer a que empresa
 * pertence: "3 vencendo" sem dizer de qual CNPJ não é informação, é ansiedade.
 */

export interface Empresa {
  /** Slug estável. Razão social muda; caminho de documento arquivado não. */
  id: string;
  nome: string;
  /** Como aparece quando o espaço é curto. */
  apelido: string;
  papel: "PRODUTORA" | "DISTRIBUIDORA";
}

export const TODAS = "todas";

interface Props {
  empresas: readonly Empresa[];
  /** {@link TODAS} para a visão consolidada. */
  selecionada: string;
  aoSelecionar(id: string): void;
}

export function SeletorDeEmpresa({ empresas, selecionada, aoSelecionar }: Props) {
  return (
    <div className="ui-seletor-empresa" role="group" aria-label="Empresa">
      <button
        type="button"
        className={`ui-seletor-empresa__opcao${selecionada === TODAS ? " ui-seletor-empresa__opcao--ativa" : ""}`}
        aria-pressed={selecionada === TODAS}
        onClick={() => aoSelecionar(TODAS)}
      >
        Todas as empresas
      </button>

      {empresas.map((empresa) => (
        <button
          key={empresa.id}
          type="button"
          className={`ui-seletor-empresa__opcao${selecionada === empresa.id ? " ui-seletor-empresa__opcao--ativa" : ""}`}
          aria-pressed={selecionada === empresa.id}
          onClick={() => aoSelecionar(empresa.id)}
          title={empresa.nome}
        >
          {empresa.apelido}
        </button>
      ))}
    </div>
  );
}
